<template>
  <div>
    <div class="columns">
        <div class="column is-9">
            <b-field>
                <b-input v-model="searchField" placeholder="Enter customer number"></b-input>
            </b-field>
        </div>
        <div class="column is-3">
            <a class="button full-width-button is-primary" :disabled="!searchField" :class="{'is-loading': isLoading}" @click="searchRecord">
                <span class="icon is-small">
                    <i class="fas fa-search"></i>
                </span>
                <span>Search</span>
            </a>
        </div>
    </div>
    <p v-if="!noRecordFound && !isLoading && !customer">Please enter customer contact to fetch customer details.</p>
    <p v-if="isLoading">Fetching customer details...</p>
    <p v-if="noRecordFound">No customer record found.</p>
    <div class="card" v-if="customer">
        <div class="card-content">
            <b-tabs type="is-boxed" v-model="activeTab">
                <b-tab-item label="Information">
                    <div class="customer-record">
                        <p class="subtitle">Contact: {{customer.contact}}</p>
                        <p class="subtitle">City: {{customer.city.name}}</p>
                        <p class="subtitle">City manager: {{customer.city.manager.name}} ({{customer.city.manager.contact}})</p>
                    </div>
                    <div class="customer-record">
                        <p class="subtitle">Signup date: {{ new Date(customer.signupDate) | moment("Do MMM'YYYY")}}</p>
                        <p class="subtitle">Wallet balance: {{customer.walletBalance | currency('Rs.')}}</p>
                    </div>
                    <p class="subtitle">Update wallet balance</p>
                    <div class="columns">
                        <div class="column">
                            <b-field>
                                <b-input v-model.number="transaction.amount" placeholder="Enter amount"></b-input>
                            </b-field>
                        </div>
                        <div class="column">
                            <b-field>
                                <b-input v-model="transaction.reason" placeholder="Enter update reason"></b-input>
                            </b-field>
                        </div>
                        <div class="column">
                            <b-field>
                                <b-input v-model="transaction.reference" placeholder="Enter reference id"></b-input>
                            </b-field>
                        </div>
                        <div class="column">
                            <a class="button full-width-button is-primary" :disabled="!transaction.amount" :class="{'is-loading': isLoading}" @click="updateWalletBalance">
                                <span class="icon is-small">
                                    <i class="fas fa-plus"></i>
                                </span>
                                <span>Add</span>
                            </a>
                        </div>
                    </div>
                </b-tab-item>
                <b-tab-item label="Orders">
                    <input type="date" @input="getOrders">
                    <p v-if="!orders">Customer hasn't placed any orders yet.</p>
                    <b-collapse class="card mt-1" :open="false" v-for="order in orders" :key="order.id">
                        <div slot="trigger" class="panel-heading">
                            <div class="customer-record">
                                <p><i class="fas fa-user pr-1"></i>{{order.customerDetails.name}}</p>
                                <p><i class="fas fa-phone pr-1"></i>{{order.customerDetails.contact}}</p>
                                <p><i class="fas fa-clock pr-1"></i>{{ new Date(order.deliveryOptionDate) | moment("DD/MM/YYYY, h:mm:ss A")}}</p>
                                <p :title="order.cancellationReason || ''"><i class="fas fa-truck pr-1"></i>{{order.orderStatus}}</p>
                            </div>
                        </div>
                        <div class="card-content">
                            <strong>Order details</strong>
                            <div class="customer-record mb-1">
                                <p>Order id: {{order.docId}}</p>
                                <p :title="order.shippingAddress">Shipping address: {{order.shippingAddress | truncate(30)}}</p>
                                <p>Delivery boy: Romesh patel (+918866323155)</p>
                            </div>
                            <strong>Payment details</strong>
                            <div class="customer-record mb-1">
                                <p>Total cost: {{order.totalCost | currency('Rs.')}}</p>
                                <p>Delivery charges: {{order.deliveryCharges | currency('Rs.')}}</p>
                                <p>Payment mode: {{order.paymentMode}}</p>
                                <p>Amount collectable: {{order.amountPayable || 0  | currency('Rs.')}}</p>
                            </div>
                            <p class="mt-1">Order items</p>
                            <table class="table is-fullwidth">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Image</th>
                                        <th>Name</th>
                                        <th>How much</th>
                                        <th>Rate</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in order.orderItems" :key="index">
                                        <td>{{index+1}}</td>
                                        <td>
                                            <a :href="item.imageUrl" target="_blank">
                                                <img :src="item.imageUrl" :alt="item.name" class="image is-48x48">
                                            </a>
                                        </td>
                                        <td>{{item.name}}</td>
                                        <td>{{item.quantity}} x {{item.howMuch}}</td>
                                        <td>{{item.ourPrice | currency('Rs.')}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </b-collapse>
                </b-tab-item>
            </b-tabs>
        </div>
    </div>
  </div>
</template>

<script>
import RecordsService from './service';
export default {
  name: 'records',

  data() {
    return {
      isLoading: false,
      searchField:
        process.env.NODE_ENV === 'development' ? '+919725251064' : null,
      customer: null,
      noRecordFound: false,
      activeTab: 0,
      orders: null,
      transaction: {
        amount: null,
        reason: null,
        reference: null
      }
    };
  },

  methods: {
    searchRecord() {
      this.isLoading = true;

      RecordsService.getCustomerDetails(this.searchField).then(customer => {
        if (!customer) {
          this.noRecordFound = true;
        } else {
          this.customer = customer;
        }

        this.isLoading = false;
      });
    },

    getOrders(date) {
      RecordsService.getOrders(this.customer.docId, date.target.value).then(
        orders => {
          this.orders = orders;
        }
      );
    },

    updateWalletBalance() {
      this.isLoading = true;

      RecordsService.updateWalletBalance(this.customer, this.transaction).then(
        () => {
          this.isLoading = false;
          this.transaction = {};
          this.$toast.open('Wallet balance updated');
        }
      );
    }
  }
};
</script>

<style scoped>
.customer-record {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/pages/records/Records.vue